import React, { useState, useEffect } from 'react';
import './RapportsAbsences.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminSidebar from '../../components/AdminSidebar';
import { CalendarIcon, UsersIcon, AlertIcon, CheckIcon } from '../../components/Icons';

function RapportsAbsences() {
  const [rapports, setRapports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRapport, setSelectedRapport] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [filters, setFilters] = useState({
    statut: '',
    classe: '',
    date_debut: '',
    date_fin: ''
  });
  const [stats, setStats] = useState({
    total_rapports: 0,
    total_absences: 0,
    total_retards: 0,
    nouveaux: 0
  });

  useEffect(() => {
    loadRapports();
    loadStats();
  }, [filters]);

  const loadRapports = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });

      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/rapports-absences?${params}`);
      const data = await response.json();
      
      if (data.success) {
        setRapports(data.data.data || []);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadStats = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.date_debut) params.append('date_debut', filters.date_debut);
      if (filters.date_fin) params.append('date_fin', filters.date_fin);

      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/rapports-absences/statistiques?${params}`);
      const data = await response.json();
      
      if (data.success) {
        setStats(data.data.resume || {});
      }
    } catch (error) {
      console.error('Erreur stats:', error);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const marquerLu = async (rapportId) => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/rapports-absences/${rapportId}/marquer-lu`, {
        method: 'POST'
      });
      
      if (response.ok) {
        loadRapports();
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const marquerTraite = async (rapportId, commentaire = '') => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/rapports-absences/${rapportId}/marquer-traite`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ commentaire })
      });
      
      if (response.ok) {
        loadRapports();
        setShowDetailModal(false);
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const voirDetails = async (rapport) => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/rapports-absences/${rapport.id}`);
      const data = await response.json();
      
      if (data.success) {
        setSelectedRapport(data.data);
        setShowDetailModal(true);
        
        // Marquer comme lu automatiquement
        if (rapport.statut === 'nouveau') {
          marquerLu(rapport.id);
        }
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const getStatutBadge = (statut) => {
    const badges = {
      'nouveau': { color: '#dc3545', text: 'Nouveau', icon: '🔴' },
      'lu': { color: '#ffc107', text: 'Lu', icon: '👁️' },
      'traite': { color: '#28a745', text: 'Traité', icon: '✅' }
    };
    
    const badge = badges[statut] || badges['nouveau'];
    
    return (
      <span 
        className="statut-badge" 
        style={{ backgroundColor: badge.color }}
      >
        {badge.icon} {badge.text}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminSidebar activePage="rapports-absences" />
      
      <div className="admin-container">
        <main className="admin-content">
          <div className="page-header">
            <h1>📋 Rapports d'Absences</h1>
            <p>Suivi des absences signalées par les professeurs</p>
          </div>

          {/* Statistiques */}
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon" style={{ backgroundColor: '#0078D7' }}>
                <CalendarIcon size={24} color="#fff" />
              </div>
              <div className="stat-content">
                <div className="stat-number">{stats.total_rapports || 0}</div>
                <div className="stat-label">Total rapports</div>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon" style={{ backgroundColor: '#dc3545' }}>
                <UsersIcon size={24} color="#fff" />
              </div>
              <div className="stat-content">
                <div className="stat-number">{stats.total_absences || 0}</div>
                <div className="stat-label">Total absences</div>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon" style={{ backgroundColor: '#ffc107' }}>
                <AlertIcon size={24} color="#fff" />
              </div>
              <div className="stat-content">
                <div className="stat-number">{stats.total_retards || 0}</div>
                <div className="stat-label">Total retards</div>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon" style={{ backgroundColor: '#28a745' }}>
                <CheckIcon size={24} color="#fff" />
              </div>
              <div className="stat-content">
                <div className="stat-number">{stats.nouveaux || 0}</div>
                <div className="stat-label">Nouveaux rapports</div>
              </div>
            </div>
          </div>

          {/* Filtres */}
          <div className="filters-section">
            <div className="filters-row">
              <div className="filter-group">
                <label>Statut</label>
                <select 
                  value={filters.statut} 
                  onChange={(e) => handleFilterChange('statut', e.target.value)}
                >
                  <option value="">Tous les statuts</option>
                  <option value="nouveau">Nouveau</option>
                  <option value="lu">Lu</option>
                  <option value="traite">Traité</option>
                </select>
              </div>
              
              <div className="filter-group">
                <label>Classe</label>
                <select 
                  value={filters.classe} 
                  onChange={(e) => handleFilterChange('classe', e.target.value)}
                >
                  <option value="">Toutes les classes</option>
                  <option value="6ème">6ème</option>
                  <option value="5ème">5ème</option>
                  <option value="4ème">4ème</option>
                  <option value="3ème">3ème</option>
                  <option value="2nde">2nde</option>
                  <option value="1ère">1ère</option>
                  <option value="Terminale">Terminale</option>
                </select>
              </div>
              
              <div className="filter-group">
                <label>Date début</label>
                <input 
                  type="date" 
                  value={filters.date_debut}
                  onChange={(e) => handleFilterChange('date_debut', e.target.value)}
                />
              </div>
              
              <div className="filter-group">
                <label>Date fin</label>
                <input 
                  type="date" 
                  value={filters.date_fin}
                  onChange={(e) => handleFilterChange('date_fin', e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Tableau des rapports */}
          <div className="rapports-section">
            {loading ? (
              <div className="loading-state">
                <div className="spinner"></div>
                <p>Chargement des rapports...</p>
              </div>
            ) : (
              <div className="table-container">
                <table className="rapports-table">
                  <thead>
                    <tr>
                      <th>Date cours</th>
                      <th>Professeur</th>
                      <th>Classe</th>
                      <th>Matière</th>
                      <th>Absences</th>
                      <th>Retards</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rapports.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="no-data">
                          Aucun rapport d'absence trouvé
                        </td>
                      </tr>
                    ) : (
                      rapports.map(rapport => (
                        <tr key={rapport.id} className={rapport.statut === 'nouveau' ? 'nouveau-rapport' : ''}>
                          <td>{formatDate(rapport.date_cours)}</td>
                          <td>{rapport.enseignant_prenom} {rapport.enseignant_nom}</td>
                          <td><span className="classe-badge">{rapport.classe}</span></td>
                          <td>{rapport.matiere}</td>
                          <td>
                            <span className="count-badge absences">{rapport.nombre_absences}</span>
                          </td>
                          <td>
                            <span className="count-badge retards">{rapport.nombre_retards}</span>
                          </td>
                          <td>{getStatutBadge(rapport.statut)}</td>
                          <td>
                            <button 
                              className="btn-action btn-view"
                              onClick={() => voirDetails(rapport)}
                            >
                              👁️ Voir
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Modal détails */}
          {showDetailModal && selectedRapport && (
            <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
              <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>📋 Détails du rapport d'absence</h3>
                  <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
                </div>
                
                <div className="modal-body">
                  <div className="rapport-info">
                    <div className="info-row">
                      <div className="info-item">
                        <strong>Date du cours :</strong> {formatDate(selectedRapport.date_cours)}
                      </div>
                      <div className="info-item">
                        <strong>Professeur :</strong> {selectedRapport.enseignant_prenom} {selectedRapport.enseignant_nom}
                      </div>
                    </div>
                    <div className="info-row">
                      <div className="info-item">
                        <strong>Classe :</strong> {selectedRapport.classe}
                      </div>
                      <div className="info-item">
                        <strong>Matière :</strong> {selectedRapport.matiere}
                      </div>
                    </div>
                    <div className="info-row">
                      <div className="info-item">
                        <strong>Signalé le :</strong> {formatDateTime(selectedRapport.created_at)}
                      </div>
                      <div className="info-item">
                        <strong>Statut :</strong> {getStatutBadge(selectedRapport.statut)}
                      </div>
                    </div>
                  </div>

                  <div className="details-section">
                    <h4>📝 Détails des absences et retards</h4>
                    <div className="details-list">
                      {selectedRapport.details && selectedRapport.details.absences ? 
                        selectedRapport.details.absences.map((absence, index) => (
                          <div key={index} className="detail-item">
                            <div className="student-info">
                              <span className="student-name">
                                {absence.etudiant_prenom} {absence.etudiant_nom}
                              </span>
                              <span className={`type-badge ${absence.type}`}>
                                {absence.type === 'absent' ? '❌ Absent' : '⏰ Retard'}
                              </span>
                            </div>
                            {absence.motif && (
                              <div className="motif">
                                <strong>Motif :</strong> {absence.motif}
                              </div>
                            )}
                            {absence.heure_arrivee && (
                              <div className="heure-arrivee">
                                <strong>Heure d'arrivée :</strong> {absence.heure_arrivee}
                              </div>
                            )}
                          </div>
                        )) : (
                          <p>Aucun détail disponible</p>
                        )
                      }
                    </div>
                  </div>

                  {selectedRapport.commentaire_admin && (
                    <div className="commentaire-section">
                      <h4>💬 Commentaire administrateur</h4>
                      <p>{selectedRapport.commentaire_admin}</p>
                    </div>
                  )}
                </div>
                
                <div className="modal-actions">
                  <button 
                    className="btn-cancel" 
                    onClick={() => setShowDetailModal(false)}
                  >
                    Fermer
                  </button>
                  {selectedRapport.statut !== 'traite' && (
                    <button 
                      className="btn-confirm"
                      onClick={() => marquerTraite(selectedRapport.id, 'Rapport traité par l\'administration')}
                    >
                      ✅ Marquer comme traité
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default RapportsAbsences;